export enum UserRoleEnum {
  USER = 'user',
  OWNER = 'owner',
  MANAGER = 'manager',
  ADMINISTRATOR = 'administrator',
  EMPLOYEE = 'employee',
}
